module.exports = __webpack_public_path__ + "img/zudongq2.7b6ce760.png";